module.exports = __webpack_public_path__ + "img/kmys.ff04c4e0.svg";